import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import API from './API'
import { Alert } from '@mui/material'

const GoogleAuthCallback = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const [code] = useState(queryParams.get('code'))
  const [error, setError] = useState(false)
  useEffect(() => {
    if (!code) {
      navigate('/')
    } else {
      API.get('/settings/googleauthcallback?code=' + code)
      .then(res => {
        if (res.status === 200) {
          navigate('/site-configuration?tab=calendar&success=googleCalendar')
        } else {
          setError(true)
        }
      })
    }
  }, [code])
  if (error) return (
    <Alert severity='error'>Unable to Link Calendar</Alert>
  )
}

export default GoogleAuthCallback
